<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark mb-3">
        <div class="container">
            <router-link :to="{ name: 'home' }" class="navbar-brand">
                {{ $t("translation.appName") }}
            </router-link>

            <button
                    class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#app-navbar"
                    aria-controls="app-navbar"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="app-navbar">
                <ul class="navbar-nav mr-auto">
                    <template v-if="authLogged">
                        <router-link :to="{ name: 'home' }" tag="li" class="nav-item" exact>
                            <a class="nav-link">
                                {{ $t("translation.homepage") }}
                            </a>
                        </router-link>
                        <li class="nav-item dropdown">
                            <ul class="navbar-nav">
                                <li class="nav-item dropdown">
                                    <a
                                        class="nav-link dropdown-toggle"
                                        href="#" id="user-dropdown"
                                        role="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        {{ $t(`translation.users`) }}
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="language-dropdown">
                                        <router-link v-if="authRoleId === constants.USER_ROLE_ADMIN" :to="{ name: 'manager.list' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.schoolManagers") }}
                                        </router-link>
                                        <router-link v-if="authRoleId !== constants.USER_ROLE_TEACHER" :to="{ name: 'teacher.list' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.teachers") }}
                                        </router-link>
                                        <router-link :to="{ name: 'student.list' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.students") }}
                                        </router-link>
                                        <router-link
                                            v-if="authRoleId === constants.USER_ROLE_MANAGER
                                                || authRoleId === constants.USER_ROLE_TEACHER"
                                            :to="{ name: 'school.courses' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.schoolCourses") }}
                                        </router-link>
                                    </div>
                                </li>
                            </ul>
                        </li>
                        <router-link v-if="authRoleId === constants.USER_ROLE_ADMIN" :to="{ name: 'school.list' }" tag="li" class="nav-item" exact>
                            <a class="nav-link">
                                {{ $t("translation.schools") }}
                            </a>
                        </router-link>
                        <li class="nav-item dropdown" v-if="authRoleId === constants.USER_ROLE_ADMIN">
                            <ul class="navbar-nav">
                                <li class="nav-item dropdown">
                                    <a
                                        class="nav-link dropdown-toggle"
                                        href="#" id="course-management-dropdown"
                                        role="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        {{ $t(`translation.courseManagement`) }}
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="language-dropdown">
                                        <router-link v-if="authRoleId === constants.USER_ROLE_ADMIN" :to="{ name: 'course.courses' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.courses") }}
                                        </router-link>
                                        <router-link v-if="authRoleId === constants.USER_ROLE_ADMIN" :to="{ name: 'lesson.lessons' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.lessons") }}
                                        </router-link>
                                        <router-link v-if="authRoleId === constants.USER_ROLE_ADMIN" :to="{ name: 'topic.topics' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.topics") }}
                                        </router-link>
                                        <router-link v-if="authRoleId === constants.USER_ROLE_ADMIN" :to="{ name: 'quiz.quizzes' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.quizzes") }}
                                        </router-link>
                                        <router-link v-if="authRoleId === constants.USER_ROLE_ADMIN" :to="{ name: 'question.questions' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.questions") }}
                                        </router-link>
                                        <router-link v-if="authRoleId === constants.USER_ROLE_ADMIN" :to="{ name: 'certificate.certificates' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.certificates") }}
                                        </router-link>
                                        <router-link v-if="authRoleId === constants.USER_ROLE_ADMIN" :to="{ name: 'badge.badges' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.badges") }}
                                        </router-link>
                                    </div>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown" v-if="authRoleId === constants.USER_ROLE_ADMIN">
                            <ul class="navbar-nav">
                                <li class="nav-item dropdown">
                                    <a
                                        class="nav-link dropdown-toggle"
                                        href="#"
                                        id="ad-dropdown"
                                        role="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        {{ $t(`translation.adNewsManagement`) }}
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="language-dropdown">
                                        <router-link v-if="authRoleId === constants.USER_ROLE_ADMIN" :to="{ name: 'ad.ads' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.ads") }}
                                        </router-link>
                                        <router-link v-if="authRoleId === constants.USER_ROLE_ADMIN" :to="{ name: 'news.news' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.news") }}
                                        </router-link>
                                    </div>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown" v-if="authRoleId === constants.USER_ROLE_ADMIN">
                            <ul class="navbar-nav">
                                <li class="nav-item dropdown">
                                    <a
                                        class="nav-link dropdown-toggle"
                                        href="#"
                                        id="email-template-dropdown"
                                        role="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        {{ $t("translation.emailTemplates") }}
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="language-dropdown">
                                        <router-link :to="{ name: 'email.finish.course' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.receivesCertificate") }}
                                        </router-link>
                                        <router-link :to="{ name: 'email.finish.lesson' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.receivesBadge") }}
                                        </router-link>
                                        <router-link :to="{ name: 'email.enroll.course' }" class="dropdown-item" tag="a" exact>
                                            {{ $t("translation.enrollsCourse") }}
                                        </router-link>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </template>
                </ul>
                <ul class="navbar-nav">
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#" id="language-dropdown"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false">
                            {{ $t(`translation.${authCurrentLang}`) }}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="language-dropdown">
                            <a
                                    v-for="language in languages"
                                    :key="language.language"
                                    class="dropdown-item"
                                    href="#"
                                    @click.prevent="lang(language.language, language.direction)"
                            >
                                {{ $t(`translation.${language.language}`) }}
                            </a>
                        </div>
                    </li>
                    <li class="nav-item dropdown" v-if="authLogged">
                        <a
                                class="nav-link dropdown-toggle"
                                href="#" id="auth-dropdown"
                                role="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                        >
                            {{ authName }}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="user-dropdown">
                            <router-link
                                    :to="{ name: 'auth.profile' }"
                                    class="dropdown-item"
                            >
                                {{ $t("translation.profile") }}
                            </router-link>
                            <div class="dropdown-divider"></div>
                            <a href="#" class="dropdown-item" @click.prevent="logout">
                                {{ $t("translation.logout") }}
                            </a>
                        </div>
                    </li>
                    <template v-else>
                        <router-link :to="{ name: 'auth.login' }" tag="li" class="nav-item">
                            <a class="nav-link">
                                {{ $t("translation.login") }}
                            </a>
                        </router-link>
                        <!--<router-link-->
                                <!--:to="{ name: 'auth.register' }"-->
                                <!--tag="li" class="nav-item">-->
                            <!--<a class="nav-link">-->
                                <!--{{ $t("translation.register") }}-->
                            <!--</a>-->
                        <!--</router-link>-->
                    </template>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    import authMixin from '../mixins/auth';
    import * as constants from '../utils/constants';

    export default {
        mixins: [
            authMixin,
        ],
        data() {
            return {
                constants,
            };
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Header.vue